import React from 'react';
import { Helmet } from 'react-helmet';
export function SEO() {
  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Hardy Blend Web Design & Mobile App Development',
    alternateName: 'Hardy Blend',
    url: 'https://hardyblend.com',
    logo: 'https://hardyblend.com/logo.png',
    description: 'Professional web design and mobile app development services in London. We build scalable, robust, and beautiful digital solutions for businesses worldwide.',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '17 Belvedere Rd',
      addressLocality: 'London',
      postalCode: 'N9 9YT',
      addressCountry: 'GB'
    },
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+44-7921-876472',
      contactType: 'customer service',
      email: 'info@hardyblend.com',
      availableLanguage: ['English']
    },
    sameAs: ['https://facebook.com/hardyblend', 'https://twitter.com/hardyblend', 'https://instagram.com/hardyblend', 'https://linkedin.com/company/hardyblend']
  };
  const localBusinessSchema = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'Hardy Blend Web Design & Mobile App Development',
    image: 'https://hardyblend.com/logo.png',
    '@id': 'https://hardyblend.com',
    url: 'https://hardyblend.com',
    telephone: '+44-7921-876472',
    priceRange: '££-£££',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '17 Belvedere Rd',
      addressLocality: 'London',
      postalCode: 'N9 9YT',
      addressCountry: 'GB'
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 51.6194,
      longitude: -0.0493
    },
    openingHoursSpecification: {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '09:00',
      closes: '18:00'
    },
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: '4.9',
      reviewCount: '47'
    }
  };
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [{
      '@type': 'Question',
      name: 'What services does Hardy Blend offer?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Hardy Blend specializes in web development, mobile app development (iOS & Android), UI/UX design, e-commerce solutions, backend development, and cloud services. We provide end-to-end digital solutions tailored to your business needs.'
      }
    }, {
      '@type': 'Question',
      name: 'How long does it take to build a website?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: "The timeline varies based on project complexity. A simple website typically takes 2-4 weeks, while complex web applications can take 8-12 weeks or more. We'll provide a detailed timeline during our initial consultation."
      }
    }, {
      '@type': 'Question',
      name: 'Do you develop mobile apps for both iOS and Android?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: "Yes, we develop native apps for both iOS and Android, as well as cross-platform solutions using React Native and Flutter. We'll recommend the best approach based on your requirements and budget."
      }
    }, {
      '@type': 'Question',
      name: 'How much does a website or app cost?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Costs vary based on features, complexity, and timeline. Simple websites start from £2,000, while complex web applications and mobile apps range from £10,000-£50,000+. Contact us for a detailed quote tailored to your project.'
      }
    }, {
      '@type': 'Question',
      name: 'Do you provide ongoing maintenance and support?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: "Yes, we offer comprehensive maintenance packages including security updates, bug fixes, performance optimization, and feature enhancements. We're committed to your long-term success."
      }
    }]
  };
  const serviceSchema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    serviceType: 'Web Development & Mobile App Development',
    provider: {
      '@type': 'Organization',
      name: 'Hardy Blend'
    },
    areaServed: {
      '@type': 'Country',
      name: 'United Kingdom'
    },
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'Digital Services',
      itemListElement: [{
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Web Development'
        }
      }, {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Mobile App Development'
        }
      }, {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'UI/UX Design'
        }
      }, {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'E-commerce Solutions'
        }
      }]
    }
  };
  return <Helmet data-id="element-251">
      {/* Primary Meta Tags */}
      <title data-id="element-252">
        Hardy Blend - Web Design & Mobile App Development | London, UK
      </title>
      <meta name="title" content="Hardy Blend - Web Design & Mobile App Development | London, UK" data-id="element-253" />
      <meta name="description" content="Professional web design and mobile app development services in London. We build scalable, robust, and beautiful digital solutions. Contact us: +44 7921 876472" data-id="element-254" />
      <meta name="keywords" content="web design, mobile app development, web development, UI/UX design, e-commerce, London, UK, React, iOS, Android, app development" data-id="element-255" />
      <meta name="robots" content="index, follow" data-id="element-256" />
      <meta name="language" content="English" data-id="element-257" />
      <meta name="author" content="Hardy Blend" data-id="element-258" />
      <link rel="canonical" href="https://hardyblend.com" data-id="element-259" />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" data-id="element-260" />
      <meta property="og:url" content="https://hardyblend.com" data-id="element-261" />
      <meta property="og:title" content="Hardy Blend - Web Design & Mobile App Development | London, UK" data-id="element-262" />
      <meta property="og:description" content="Professional web design and mobile app development services in London. We build scalable, robust, and beautiful digital solutions." data-id="element-263" />
      <meta property="og:image" content="https://hardyblend.com/og-image.jpg" data-id="element-264" />
      <meta property="og:locale" content="en_GB" data-id="element-265" />
      <meta property="og:site_name" content="Hardy Blend" data-id="element-266" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" data-id="element-267" />
      <meta property="twitter:url" content="https://hardyblend.com" data-id="element-268" />
      <meta property="twitter:title" content="Hardy Blend - Web Design & Mobile App Development | London, UK" data-id="element-269" />
      <meta property="twitter:description" content="Professional web design and mobile app development services in London. We build scalable, robust, and beautiful digital solutions." data-id="element-270" />
      <meta property="twitter:image" content="https://hardyblend.com/twitter-image.jpg" data-id="element-271" />

      {/* Additional SEO Tags */}
      <meta name="geo.region" content="GB-LND" data-id="element-272" />
      <meta name="geo.placename" content="London" data-id="element-273" />
      <meta name="geo.position" content="51.6194;-0.0493" data-id="element-274" />
      <meta name="ICBM" content="51.6194, -0.0493" data-id="element-275" />

      {/* Schema.org Structured Data */}
      <script type="application/ld+json" data-id="element-276">
        {JSON.stringify(organizationSchema)}
      </script>
      <script type="application/ld+json" data-id="element-277">
        {JSON.stringify(localBusinessSchema)}
      </script>
      <script type="application/ld+json" data-id="element-278">{JSON.stringify(faqSchema)}</script>
      <script type="application/ld+json" data-id="element-279">
        {JSON.stringify(serviceSchema)}
      </script>
    </Helmet>;
}